export default "__VITE_ASSET__Cs3U28nx__"